// Pre-provided profile images — 50 of them, indices 0~49.
// Files live in:  museumx/frontend/public/assets/profiles/{n}.png   (n = 0..49)
// Missing files fall back to a colored disc (hue derived from the index).

export const PROFILE_MIN = 0;
export const PROFILE_MAX = 49;
export const PROFILE_COUNT = PROFILE_MAX - PROFILE_MIN + 1;

// [0, 1, 2, ... 49] — used to render the picker grid.
export const PROFILE_INDICES = Array.from(
  { length: PROFILE_COUNT },
  (_, i) => PROFILE_MIN + i
);

export function clampProfileIndex(index) {
  const n = Math.floor(Number(index));
  if (!Number.isFinite(n)) return PROFILE_MIN;
  return Math.max(PROFILE_MIN, Math.min(PROFILE_MAX, n));
}

export function profileImageUrl(index) {
  return `${process.env.PUBLIC_URL}/assets/profiles/${clampProfileIndex(index)}.png`;
}

export function randomProfileIndex() {
  return PROFILE_MIN + Math.floor(Math.random() * PROFILE_COUNT);
}

// Stable, distinct color per index — used for the fallback disc.
export function profileFallbackColor(index) {
  const hue = (clampProfileIndex(index) * 47) % 360;
  return `hsl(${hue}, 58%, 80%)`;
}

// Fetch a (same-origin) image URL and return it as a base64 data URL.
// Used to persist the chosen profile image in localStorage.
export async function imageUrlToBase64(url) {
  const res = await fetch(url, { cache: 'force-cache' });
  if (!res.ok) throw new Error(`profile image fetch failed: ${res.status}`);
  const blob = await res.blob();
  return await new Promise((resolve, reject) => {
    const fr = new FileReader();
    fr.onload = () => resolve(fr.result);
    fr.onerror = () => reject(fr.error || new Error('FileReader failed'));
    fr.readAsDataURL(blob);
  });
}
